import React from "react";
// import Hero from "../components/Hero";
// import Videos from "../components/Videos";
// import PremiumSlider from "../components/PremiumSlider";
// import Stats from "../components/Stats";
// import Services from "../components/Services";
// import QuoteSection from "../components/QuoteSection";
// import Events from "../components/Events";
// import Reviews from "../components/Reviews";
import TempleExplorer from "../components/TempleExplorer";
import YoutubeSlider from "../components/YoutubeSlider";
import KathaShowcase from "../components/KathaShowcase";

const Home = () => {
  return (
    <>
      {/* <PremiumSlider /> */}
      <YoutubeSlider />
      <KathaShowcase />
      {/* <Services /> */}
      {/* <QuoteSection /> */}

      <TempleExplorer />
      {/* <Events /> */}
      {/* <Hero /> */}
      {/* <Videos /> */}
      {/* <Reviews /> */}
      {/* <Stats /> */}
      {/* Aap yahan ek chhota "About Preview" ya "Recent Gallery" bhi daal sakte hain */}
    </>
  );
};

export default Home;
